import { fetchApi } from '@/config/axiosSetting.ts';
import { GetAdjusterSignatureQueryResponseType } from '@/modules/Dashboard/queries/sidebarSignature/getAdjusterSignatureQuery.type.ts';

export const getAdjusterSignatureQueryFn =
  (): Promise<GetAdjusterSignatureQueryResponseType> =>
    fetchApi.get('sidebar/signature_registration/');
